import React from 'react';

/**
 * Reusable section header with overline and title.
 */
const SectionHeader = ({ overline, title, className = '', centered = false, children }) => {
  return (
    <div className={`section-header ${centered ? 'text-center' : ''} ${className}`}>
      {overline && <div className="section-header__overline">{overline}</div>}
      {title && <h2 className="section-header__title">{title}</h2>}
      {children}
    </div>
  );
};

export default SectionHeader;
